import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { QuestaoComRespostaDTO } from 'src/app/homecare/paciente/dto/questao-com-resposta.dto';
import { Paciente } from 'src/app/homecare/paciente/paciente.model';
import { PacienteService } from 'src/app/homecare/paciente/paciente.service';


@Component({
  selector: 'app-sumario-paciente-quadro-perfil-questao-destaque',
  templateUrl: './sumario-paciente-quadro-perfil-questao-destaque.component.html',
  styleUrls: ['./sumario-paciente-quadro-perfil-questao-destaque.component.css']
})
export class SumarioPacienteQuadroPerfilQuestaoDestaqueComponent implements OnInit, OnChanges {

  @Input() paciente: Paciente = null;
  
  @Input() exibirTitulo = true;
  @Input() exibirMsgNenhumRegistro = false;
  public nenhumRegistroEncontrado = false;

  public questoesComRespostaDTO: QuestaoComRespostaDTO[] = [];

  public state: 'carregando' | 'erro' | 'pronto' | 'sem_permissao';

  public componenteVisivel = true;

  constructor(
    private pacienteService: PacienteService,
    private errorHandlerService: ErrorHandlerService
  ) { }

  ngOnInit(): void {
    this.carregarDados();
  }

  ngOnChanges(changes: SimpleChanges) {
    if ( !changes.paciente.firstChange ) {
      this.carregarDados();
    }
  }

  public carregarDados(): void {
    this.componenteVisivel = true;

    if ( this.paciente && this.paciente.id ) {
      this.state = 'carregando';
  
      this.pacienteService
          .listarQuestoesEmDestaquePorPaciente( this.paciente.id )
          .pipe(
            catchError( err => {
              this.state = ((err && err.status === 403) ?  'sem_permissao' : 'erro');
              this.errorHandlerService.handle(err);
              
              return throwError(err);
            })
            , map((questoesComResposta: QuestaoComRespostaDTO[]) => {
              this.questoesComRespostaDTO = questoesComResposta || [];
  
              this.questoesComRespostaDTO
                  .forEach(dto => {
                    try {
                      if ( dto.opcaoQuestao ) {
                        const o = JSON.parse( dto.opcaoQuestao as unknown as string );
                        dto.opcaoQuestao = o;
                      }
                    }
                    catch (e) {
                      console.error(e.message);
                      dto.opcaoQuestao = [{
                        id: 0,
                        descricao: 'Ocorreu um erro na operação: [' + e.message + ']'
                      }];
                      this.definirVisibilidadeDoComponente();
                    }
                  });
            })
          )
          .subscribe(() => {
            this.state = 'pronto';
            this.definirVisibilidadeDoComponente();
          });
    }
    else {
      this.questoesComRespostaDTO = [];
    }
  }

  private definirVisibilidadeDoComponente(): void {
    if ( this.state === 'pronto' && this.questoesComRespostaDTO && this.questoesComRespostaDTO.length === 0 ) {
      this.componenteVisivel = false;
    }
  }

}
